/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VideoIndexRouteImport } from './routes/video/index'
import { Route as UpscaleIndexRouteImport } from './routes/upscale/index'
import { Route as LorasIndexRouteImport } from './routes/loras/index'
import { Route as GenerationIndexRouteImport } from './routes/generation/index'
import { Route as GalleryIndexRouteImport } from './routes/gallery/index'
import { Route as EditIndexRouteImport } from './routes/edit/index'
import { Route as AuthResetIndexRouteImport } from './routes/auth/reset/index'
import { Route as AuthRegisterIndexRouteImport } from './routes/auth/register/index'
import { Route as AuthLoginIndexRouteImport } from './routes/auth/login/index'
import { Route as AdminApproveUsersIndexRouteImport } from './routes/admin/approve-users/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VideoIndexRoute = VideoIndexRouteImport.update({
  id: '/video/',
  path: '/video/',
  getParentRoute: () => rootRouteImport,
} as any)
const UpscaleIndexRoute = UpscaleIndexRouteImport.update({
  id: '/upscale/',
  path: '/upscale/',
  getParentRoute: () => rootRouteImport,
} as any)
const LorasIndexRoute = LorasIndexRouteImport.update({
  id: '/loras/',
  path: '/loras/',
  getParentRoute: () => rootRouteImport,
} as any)
const GenerationIndexRoute = GenerationIndexRouteImport.update({
  id: '/generation/',
  path: '/generation/',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryIndexRoute = GalleryIndexRouteImport.update({
  id: '/gallery/',
  path: '/gallery/',
  getParentRoute: () => rootRouteImport,
} as any)
const EditIndexRoute = EditIndexRouteImport.update({
  id: '/edit/',
  path: '/edit/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetIndexRoute = AuthResetIndexRouteImport.update({
  id: '/auth/reset/',
  path: '/auth/reset/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRegisterIndexRoute = AuthRegisterIndexRouteImport.update({
  id: '/auth/register/',
  path: '/auth/register/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
  id: '/auth/login/',
  path: '/auth/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminApproveUsersIndexRoute = AdminApproveUsersIndexRouteImport.update({
  id: '/admin/approve-users/',
  path: '/admin/approve-users/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/edit': typeof EditIndexRoute
  '/gallery': typeof GalleryIndexRoute
  '/generation': typeof GenerationIndexRoute
  '/loras': typeof LorasIndexRoute
  '/upscale': typeof UpscaleIndexRoute
  '/video': typeof VideoIndexRoute
  '/admin/approve-users': typeof AdminApproveUsersIndexRoute
  '/auth/login': typeof AuthLoginIndexRoute
  '/auth/register': typeof AuthRegisterIndexRoute
  '/auth/reset': typeof AuthResetIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/edit': typeof EditIndexRoute
  '/gallery': typeof GalleryIndexRoute
  '/generation': typeof GenerationIndexRoute
  '/loras': typeof LorasIndexRoute
  '/upscale': typeof UpscaleIndexRoute
  '/video': typeof VideoIndexRoute
  '/admin/approve-users': typeof AdminApproveUsersIndexRoute
  '/auth/login': typeof AuthLoginIndexRoute
  '/auth/register': typeof AuthRegisterIndexRoute
  '/auth/reset': typeof AuthResetIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/edit/': typeof EditIndexRoute
  '/gallery/': typeof GalleryIndexRoute
  '/generation/': typeof GenerationIndexRoute
  '/loras/': typeof LorasIndexRoute
  '/upscale/': typeof UpscaleIndexRoute
  '/video/': typeof VideoIndexRoute
  '/admin/approve-users/': typeof AdminApproveUsersIndexRoute
  '/auth/login/': typeof AuthLoginIndexRoute
  '/auth/register/': typeof AuthRegisterIndexRoute
  '/auth/reset/': typeof AuthResetIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/edit'
    | '/gallery'
    | '/generation'
    | '/loras'
    | '/upscale'
    | '/video'
    | '/admin/approve-users'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/edit'
    | '/gallery'
    | '/generation'
    | '/loras'
    | '/upscale'
    | '/video'
    | '/admin/approve-users'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset'
  id:
    | '__root__'
    | '/'
    | '/edit/'
    | '/gallery/'
    | '/generation/'
    | '/loras/'
    | '/upscale/'
    | '/video/'
    | '/admin/approve-users/'
    | '/auth/login/'
    | '/auth/register/'
    | '/auth/reset/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EditIndexRoute: typeof EditIndexRoute
  GalleryIndexRoute: typeof GalleryIndexRoute
  GenerationIndexRoute: typeof GenerationIndexRoute
  LorasIndexRoute: typeof LorasIndexRoute
  UpscaleIndexRoute: typeof UpscaleIndexRoute
  VideoIndexRoute: typeof VideoIndexRoute
  AdminApproveUsersIndexRoute: typeof AdminApproveUsersIndexRoute
  AuthLoginIndexRoute: typeof AuthLoginIndexRoute
  AuthRegisterIndexRoute: typeof AuthRegisterIndexRoute
  AuthResetIndexRoute: typeof AuthResetIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/video/': {
      id: '/video/'
      path: '/video'
      fullPath: '/video'
      preLoaderRoute: typeof VideoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upscale/': {
      id: '/upscale/'
      path: '/upscale'
      fullPath: '/upscale'
      preLoaderRoute: typeof UpscaleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loras/': {
      id: '/loras/'
      path: '/loras'
      fullPath: '/loras'
      preLoaderRoute: typeof LorasIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/generation/': {
      id: '/generation/'
      path: '/generation'
      fullPath: '/generation'
      preLoaderRoute: typeof GenerationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery/': {
      id: '/gallery/'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof GalleryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/edit/': {
      id: '/edit/'
      path: '/edit'
      fullPath: '/edit'
      preLoaderRoute: typeof EditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset/': {
      id: '/auth/reset/'
      path: '/auth/reset'
      fullPath: '/auth/reset'
      preLoaderRoute: typeof AuthResetIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/register/': {
      id: '/auth/register/'
      path: '/auth/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login/': {
      id: '/auth/login/'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/approve-users/': {
      id: '/admin/approve-users/'
      path: '/admin/approve-users'
      fullPath: '/admin/approve-users'
      preLoaderRoute: typeof AdminApproveUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EditIndexRoute: EditIndexRoute,
  GalleryIndexRoute: GalleryIndexRoute,
  GenerationIndexRoute: GenerationIndexRoute,
  LorasIndexRoute: LorasIndexRoute,
  UpscaleIndexRoute: UpscaleIndexRoute,
  VideoIndexRoute: VideoIndexRoute,
  AdminApproveUsersIndexRoute: AdminApproveUsersIndexRoute,
  AuthLoginIndexRoute: AuthLoginIndexRoute,
  AuthRegisterIndexRoute: AuthRegisterIndexRoute,
  AuthResetIndexRoute: AuthResetIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
